import { Button } from '@heroui/react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { ArrowUpRightIcon, CheckIcon } from 'lucide-react';

import { Container } from 'src/components/container';
import { FadeIn } from 'src/components/fade-in';

export const Route = createFileRoute('/thanks')({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();
  return (
    <section className="py-22 md:py-42">
      <Container>
        <div className="flex flex-col items-center gap-4 text-center">
          <CheckIcon size={60} strokeWidth={1} />
          <FadeIn>
            <h1 className="text-4xl leading-tight">Gracias por confirmar!</h1>
          </FadeIn>

          <FadeIn delay={0.2}>
            <p className="text-xl text-balance">
              Recibimos tu respuesta y ya estamos muy emocionados de poder celebrar ese día con vos!
            </p>
          </FadeIn>

          <FadeIn delay={0.4}>
            <Button variant="outline" className="mt-12" onClick={() => navigate({ to: '/' })}>
              Volver al inicio
              <ArrowUpRightIcon />
            </Button>
          </FadeIn>
        </div>
      </Container>
    </section>
  );
}
